<app-login *ngIf="!isAuth"></app-login>
<app-home *ngIf="isAuth"></app-home>

